import { useCallback, useMemo } from "react";
import { firmwareList, updateFirmware } from "../../../../Service/Api/firmware";
import { useDebouncedApiCall, usePaginationCore } from "../../../../hooks";
import {
  appReleaseList,
  updateAppRelease,
} from "../../../../Service/Api/appRelease";
import { compareVersions } from "../utils/compareVersions";
import ReleaseManagementComponent from "../components/ReleaseManagementComponent";
import { appTableCols } from "../constants";

const AppReleaseContainer = () => {
  const { call } = useDebouncedApiCall();

  const {
    data: rowList,
    count,
    updateRow,
    paginationUI
  } = usePaginationCore({
    pageName: "AppRelease",
    fetchFn: appReleaseList,
    // deleteFn: deleteFirmwareById,
  });

  const updateClick = useCallback(
    (e, id) => {
      e?.preventDefault();
      call(async () => {
        const res = await updateAppRelease({ latest: true }, id);
        if (!res.error) {
          const findLatest = rowList.filter((row) => row.latest === true);
          updateRow([
            { id, latest: true },
            { id: findLatest[0].id, latest: false },
          ]);
        }
        return res;
      });
    },
    [call, updateRow, rowList],
  );

  const memoizedProps = useMemo(
    () => ({
      rowList: rowList.sort((a, b) => compareVersions(b, a)),
      updateClick,
      tableCols: appTableCols,
      paginationUI
    }),
    [rowList,paginationUI],
  );

  return <ReleaseManagementComponent {...memoizedProps} />;
};

export default AppReleaseContainer;
